import { render } from "./Formated.vue?vue&type=template&id=5d0f0b73&scoped=true"
import script from "./Formated.vue?vue&type=script&lang=js"
export * from "./Formated.vue?vue&type=script&lang=js"

import "./Formated.vue?vue&type=style&index=0&id=5d0f0b73&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0f0b73"]])

export default __exports__